<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <h2 class="modal-title">{{ $t('promoCodeDescriptionTitle') }}</h2>

      <p class="description">{{ $t('promoCodeDescriptionPart1') }}</p>
      <p class="description">{{ $t('promoCodeDescriptionPart2') }}</p>
      <ul>
        <li class="description">{{ $t('promoCodeDescriptionPart3') }}</li>
        <li class="description">{{ $t('promoCodeDescriptionPart4') }}</li>
      </ul>

      <main-button
        depressed
        color="#333"
        :text="$t('understand')"
        class="understand-button"
        @click="$emit('closeModal')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'promo-code-description-modal',
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 24.3125rem;
  padding: 2rem;
  border-radius: 4px;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}

.modal-title {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.045rem;
  margin-bottom: 2rem;
}

.description {
  color: #333;
  font-family: 'Source Sans Pro';
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 0;
}

.understand-button {
  width: 100%;
  margin: 2rem 0 0.5rem 0;
}

.v-input__icon {
  margin-right: 0.75rem;
}
</style>
